import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';

export interface Theme {
  canal: 'safra-pf' | 'safra-se' | 'safra-spd' | 'ag-zero' | 'safra-financeira' | 'safra-cartoes';
  type: 'mobile' | 'web';
  sigla: 'IBF' | 'MBF' | 'IBJ' | 'MBJ' | 'SPD' | 'BCD' | 'CDF' | 'SVQ';
  nome:
    | 'Safra'
    | 'Safra'
    | 'Safra Empresas'
    | 'Safra Empresas'
    | 'Safrapay Digital'
    | 'AgZero'
    | 'Safra Financeira'
    | 'Safra Cartões';
}
@Injectable({
  providedIn: 'root',
})
export class ThemeService {
  constructor(@Inject(DOCUMENT) private document: Document) {}

  public themes: Theme[] = [
    {
      canal: 'safra-pf',
      sigla: 'IBF',
      type: 'web',
      nome: 'Safra',
    },
    {
      canal: 'safra-pf',
      sigla: 'MBF',
      type: 'mobile',
      nome: 'Safra',
    },
    {
      canal: 'safra-se',
      sigla: 'IBJ',
      type: 'web',
      nome: 'Safra Empresas',
    },
    {
      canal: 'safra-se',
      sigla: 'MBJ',
      type: 'mobile',
      nome: 'Safra Empresas',
    },
    {
      canal: 'safra-spd',
      sigla: 'SPD',
      type: 'mobile',
      nome: 'Safrapay Digital',
    },
    {
      canal: 'ag-zero',
      sigla: 'BCD',
      type: 'mobile',
      nome: 'AgZero',
    },
    {
      canal: 'safra-financeira',
      sigla: 'CDF',
      type: 'web',
      nome: 'Safra Financeira',
    },
    {
      canal: 'safra-cartoes',
      sigla: 'SVQ',
      type: 'mobile',
      nome: 'Safra Cartões',
    },
  ];

  private theme: Theme;

  /**
   * Carrega dinamicamente o tema para um componente ou modulo
   * @param styleName nome do tema
   * Temas devem ficar disponiveis no angular.json e na /style/themes
   */
  private loadStyle(theme: Theme) {
    const head = this.document.getElementsByTagName('head')[0];

    const themeLink = this.document.getElementById('client-theme') as HTMLLinkElement;

    if (themeLink) {
      themeLink.href = `${theme.canal}.css`;
    } else {
      const style = this.document.createElement('link');
      style.id = 'client-theme';
      style.rel = 'stylesheet';
      style.href = `${theme.canal}.css`;

      head.appendChild(style);
    }
  }

  getTheme(): Theme {
    return this.theme;
  }

  setTheme(sigla: string) {
    const theme = this.themes.find((item) => item.sigla === sigla);
    if (theme) {
      this.theme = theme;
      this.loadStyle(theme);
    } else {
      const spdTheme = this.themes.find((item) => item.canal === 'safra-pf');
      this.loadStyle(spdTheme);
      this.theme = spdTheme;
    }
  }
}
